import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PIPELINE_STAGES, stageLabel } from "../lib/api";

const Stat = ({ label, value, sub }) => (
  <div className="bg-[#0A0A0A] border border-white/5 p-8">
    <div className="label-caps mb-4">{label}</div>
    <div className="font-editorial text-6xl tracking-tighter mb-1">{value}</div>
    {sub && <div className="text-xs text-white/40 font-mono-alt">{sub}</div>}
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats").then(({ data }) => setStats(data)); }, []);

  return (
    <div className="p-12">
      <div className="mb-12">
        <div className="label-caps mb-4">Overview</div>
        <h1 className="font-editorial text-6xl tracking-tighter leading-none">Dashboard</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 mb-12">
        <Stat label="Total Projects" value={stats?.total_projects ?? "–"} />
        <Stat label="Pipeline Value" value={stats ? `$${(stats.pipeline_value || 0).toLocaleString()}` : "–"} />
        <Stat label="Collected" value={stats ? `$${(stats.collected || 0).toLocaleString()}` : "–"} />
        <Stat label="Active Stage" value={stats ? Object.values(stats.by_stage).reduce((a,b)=>a+b, 0) - (stats.by_stage?.delivered || 0) : "–"} sub="In production" />
      </div>

      <div>
        <div className="label-caps mb-6">Stage Breakdown</div>
        <div className="space-y-px bg-white/5">
          {PIPELINE_STAGES.map((s) => (
            <div key={s.key} className="bg-[#0A0A0A] p-6 flex items-center justify-between" data-testid={`stage-row-${s.key}`}>
              <div className="flex items-center gap-4">
                <span className="status-dot" style={{ background: s.color }} />
                <span className="font-editorial text-xl">{stageLabel(s.key)}</span>
              </div>
              <div className="font-mono-alt text-2xl">{stats?.by_stage?.[s.key] ?? 0}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
